import { useQuery } from '@apollo/client';
import uniqBy from 'lodash/uniqBy';
import { useMemo } from 'react';

import GetSuggestedTags from './GetSuggestedTags.graphql';

const TAGS_FROM_LIST = 3;
const MAX_SUGGESTED_TAGS = 5;

export function selectSuggestedTags({
  recentlyUsedTags,
  topUsedTags,
  numTagsFromList,
  maxSuggestedTags,
  existingTags,
}) {
  const suggestions = uniqBy(
    recentlyUsedTags.slice(0, numTagsFromList).concat(topUsedTags),
    'tag'
  );

  return (
    suggestions
      // Filter out any tags that already exist on the video
      .filter(suggestion => !existingTags.has(suggestion.tag))
      .slice(0, maxSuggestedTags)
  );
}

export default function useSuggestedTags(existingTags) {
  const { data } = useQuery(GetSuggestedTags);

  return useMemo(() => {
    if (!data?.suggestedTags) {
      return [];
    }

    const { recentlyUsedTags, topUsedTags } = data.suggestedTags;

    return selectSuggestedTags({
      recentlyUsedTags,
      topUsedTags,
      numTagsFromList: TAGS_FROM_LIST,
      maxSuggestedTags: MAX_SUGGESTED_TAGS,
      existingTags,
    });
  }, [data, existingTags]);
}
